export default __webpack_public_path__ + "static/andy1-637fa6825f1942d265c8f4f1abba52ab.png";